import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag, DBRadioButton } from '_components';
import styles from './Common.module.css'

class SpeechCognitiveLinguistics extends React.Component {

    render() {
        return (
            <div>

                <div className={styles.formRowSetting}>
                <div className={styles.flgCol}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Cognitive Linguistics' />
                    </div>
                    <div className={styles.colHeader}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGSTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
                    </div>

                    <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                        Comments
                    </div>
                    </div>
                <div className={styles.formRowSetting}>
                <div className={styles.col} />
                <div className={styles.colRadio}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSCOGCOMMENTS'
                        className={styles.textarea}
                    />
                    </div>
                </div>
        
                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.orientationFlagged} flagText='Orientation' />
                   </div>

                   <div className={styles.colInnerHeader}>
                        Orientation
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGORIENTATION'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGORIENTATION'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                       <ObjectiveFlag className={styles.flag} flagged={this.props.attentionFlagged} flagText='Attention' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Attention
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGATTENTION'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGATTENTION'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.longTermFlagged} flagText='Long Term Recall' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Long Term Recall
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGLONGTERM'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGLONGTERM'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.shortTermFlagged} flagText='Short Term Recall' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Short Term Recall
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGSHORTTERM'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGSHORTTERM'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.problemSolvingFlagged} flagText='Problem Solving' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Problem Solving
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGPROBLEM'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGPROBLEM'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.reasoningFlagged} flagText='Reasoning' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Reasoning
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGREASONING'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGREASONING'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.orgFlagged} flagText='Organization/Sequencing' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Organization/Sequencing
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGORGANIZATION'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGORGANIZATION'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.exeFlagged} flagText='Executive Function' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Executive Function
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGEXECUTIVE'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSCOGEXECUTIVE'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGSTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGSTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGSTATUS !== 'WNL'),
        orientationFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGORIENTATION !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGORIENTATION !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGORIENTATION !== 'WNL'),
        attentionFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGATTENTION !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGATTENTION !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGATTENTION !== 'WNL'),
        longTermFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGLONGTERM !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGLONGTERM !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGLONGTERM !== 'WNL'),
        shortTermFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGSHORTTERM !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGSHORTTERM !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGSHORTTERM !== 'WNL'),
        problemSolvingFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGPROBLEM !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGPROBLEM !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGPROBLEM !== 'WNL'),
        reasoningFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGREASONING !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGREASONING !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGREASONING !== 'WNL'),
        orgFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGORGANIZATION !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGORGANIZATION !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGORGANIZATION !== 'WNL'),
        exeFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGEXECUTIVE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGEXECUTIVE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSCOGEXECUTIVE !== 'WNL')
    };
}

const connectedSpeechCognitiveLinguistics = connect(mapStateToProps)(SpeechCognitiveLinguistics);
export { connectedSpeechCognitiveLinguistics as SpeechCognitiveLinguistics };


